import { selectAwaitedRequest, deleteAwaitedRequest } from "../awaitedRequests";
import { buildHeaders, validateApiRequest } from "../helpers";
import httpMethods from "../http/http";
import { actions } from "../../components/organisms/Alert/alert.reducers";
import { ALERT_TIMEOUT, EMPTY_STRING } from "../../constants";
import getErrorMessages from "../helpers/getErrorMessages";
import { actions as spinnerActions } from "../../components/organisms/Spinner/spinner.reducers";
import { captureMessage } from "@sentry/react";

const { setAlert } = actions;
const { addSpinner, removeSpinner } = spinnerActions;

const doFetch = (props) => {
  const {
    url,
    method = "GET",
    config = {},
    getState,
    dispatch,
    errorMessage,
    successMessage,
    showSpinner = false,
    spinner = EMPTY_STRING,
    useCache = false,
    stubData,
    isFormData = false,
    rejectWithValue,
  } = props;

  try {
    if (!getState || typeof getState !== "function") {
      throw new Error(
        "getState is required and must have a getState method defined on it"
      );
    }

    if (!dispatch || typeof dispatch !== "function") {
      throw new Error("dispatch is required and must be a function");
    }

    // Validate Request
    validateApiRequest(url, method);
    // Handling API with Mock Data

    if (stubData) {
      return stubData;
    }

    if (useCache) {
      // TODO: Add functionality to get the data from cache
    }

    const isAlreadyAwaitedRequest = selectAwaitedRequest(getState(), {
      url,
      method: method.toLowerCase(),
    });

    if (isAlreadyAwaitedRequest) {
      return rejectWithValue("Request is already pending.");
    }

    if (showSpinner) {
      // TODO: Need to add logic for spinner
      console.log("showSpinner is true");
    }

    if (spinner) {
      dispatch(addSpinner(spinner));
    }

    const newConfig = { ...config, ...buildHeaders(url, config, isFormData) };

    return httpMethods[method](url, newConfig, { successMessage, errorMessage })
      .then((body) => {
        if (spinner) dispatch(removeSpinner(spinner));
        return Promise.resolve(body);
      })
      .catch(async (exception) => {
        if (spinner) dispatch(removeSpinner(spinner));
        const apiErrorMessage = await getErrorMessages(exception, errorMessage);
        const detailedErrorInfo = { url, updatedBody: config?.body, exception };
        captureMessage(
          `${
            apiErrorMessage.exceptionMessage || apiErrorMessage
          }\n${JSON.stringify(detailedErrorInfo)}`
        );
        dispatch(setAlert({ message: apiErrorMessage }));
        setTimeout(() => {
          dispatch(setAlert());
        }, ALERT_TIMEOUT);
        throw exception;
      })
      .then((api_responses) => {
        deleteAwaitedRequest({
          url,
          method: method.toLowerCase(),
        });

        return api_responses;
      });
  } catch (exception) {
    console.log("Exception occurred: ", exception);
    throw exception;
  }
};

export default doFetch;
